export enum AvailableState {
    success = 'success',
    error = 'error',
}
